import React from 'react';
import { Image, Text, View, Linking } from 'react-native';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import Project from '../../../../../Common/DTO/Project';
import { styles } from './ProjectPresentationViewStyle';
import { useWindowSizeContext } from '../../../../../Common/contexts/WindowSizeContext';

interface ProjectPresentationViewProps {
  project: Project;
}

const getPropertyUrl = (type: string) =>
  `https://beebondsstorage.blob.core.windows.net/files/web/${type}.png`;

const getPropertyValue = (property: any) =>
  property.value || Helpers.getCorrectTranslation(property.valueTranslated);

const ProjectDescription = ({ description }: { description: string }) => {
  const phrasesCibles = [
    { phrase: 'Lire la communication du porteur de projet.', url: 'https://jo.my/meganisi-starck-cp' },
    { phrase: 'Lees de mededeling van de projecteigenaar.', url: 'https://jo.my/meganisi-starck-cp' },
    { phrase: 'Manaux Châteaux', url: 'https://manaux.com/' },
    { phrase: 'The Collectionist', url: 'https://www.lecollectionist.com/en/luxury-rental/villa-de-l-hermitage-cap-ferret' },
  ];

  const phraseCible = phrasesCibles.find(({ phrase }) => description.includes(phrase));
  if (!phraseCible) {
    return <Text style={styles.boxDescription}>{description}</Text>;
  }

  const parts = description.split(phraseCible.phrase);

  return (
    <Text style={styles.boxDescription}>
      {parts[0]}
      <Text
        style={{ color: '#007bff', textDecorationLine: 'underline' }}
        onPress={() => Linking.openURL(phraseCible.url)}
      >
        {phraseCible.phrase}
      </Text>
      {parts[1]}
    </Text>
  );
};

export const ProjectPresentationView = ({ project }: ProjectPresentationViewProps) => {
  const { width: screenWidth } = useWindowSizeContext();

  const globalProjectProperties = project.projectPropertyValues.filter(
    (x) => x.projectPropertyKey.projectPropertyType.key === 'GLOBAL'
  );

  const logoUri = Helpers.getPropertyValue('LOGO', project.projectPropertyValues);

  if (globalProjectProperties.length === 0) return null;

  return (
    <View style={styles.page}>
      <ProjectDescription description={Helpers.getCorrectTranslation(project.projectDescription)} />

      {typeof logoUri === 'string' && logoUri.trim() !== '' && (
        <Image style={styles.logo} resizeMode="contain" source={{ uri: logoUri }} />
      )}

      <View style={styles.line}>
        {globalProjectProperties.map((property: any, index: number) => (
          <View
            key={index}
            style={[
              styles.box,
              {
                width: screenWidth > 800 ? '48%' : '100%',
                marginBottom: 8,
              },
            ]}
          >
            <Image
              style={styles.icon}
              source={{ uri: getPropertyUrl(property.projectPropertyKey.key) }}
            />
            <View style={{ flex: 1 }}>
              <Text style={styles.boxTitle}>
                {Helpers.getCorrectTranslation(property.projectPropertyKey.title)}
              </Text>
              <Text style={styles.boxSubTitle}>{getPropertyValue(property)}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default ProjectPresentationView;
